import { gql } from '@apollo/client';

export const GET_NOTIFICATIONS = gql`
  query GetWebNotifications(
    $coachId: String!
    $skip: Int!
    $take: Int!
    $searchQuery: String!
    $isViewed: Boolean
  ) {
    getWebNotifications(
      getWebNotifications: {
        coachId: $coachId
        skip: $skip
        take: $take
        searchQuery: $searchQuery
        isViewed: $isViewed
      }
    ) {
      webNotifications {
        id
        coachId
        description
        createdAt
        status
        title
        isViewed
        client {
          id
          profilePic
          firstName
          lastName
        }
        type
      }
      count
      chatCount
    }
  }
`;

export const SUBSCRIBE_TO_COACH_WEB_NOTIFICATIONS = gql`
  subscription coachWebNotifications($coachId: String!) {
    coachWebNotifications(coachId: $coachId) {
      id
      title
      description
      coachId
      client {
        id
        profilePic
      }
      status
      isViewed
      type
    }
  }
`;

export const VIEW_ALL_NOTIFICATIONS = gql`
  mutation changeViewStatusWebNotifications($coachId: String!) {
    changeViewStatusWebNotifications(coachId: $coachId) {
      success
      message
    }
  }
`;
